// extracted by mini-css-extract-plugin
export var circle = "uRE3hwMZO3ogwWsHGmbU";
export var root = "uwc78fqozzKQHzO9XLoC";